import { render, staticRenderFns } from "./status-badge.vue?vue&type=template&id=87c1ea60"
import script from "./status-badge.vue?vue&type=script&lang=js"
export * from "./status-badge.vue?vue&type=script&lang=js"
import style0 from "./status-badge.vue?vue&type=style&index=0&id=87c1ea60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TabloStatusIcon: require('/opt/iaravia.ru/src/components/tablo/status-icon.vue').default})
